import {
    getTauschbonusFromSails,
    getTradeInFromSails,
} from '@vfde-sails/storage';
import { SailsTariffOverviewStorage } from 'Container/App/interface';

/**
 * Get trade in from storage
 */
export const getTradeIn = (storage: SailsTariffOverviewStorage | null): boolean => !!storage && getTradeInFromSails(storage);

/**
 * Get tauschbonus from storage
 */
export const getTauschbonus = (storage: SailsTariffOverviewStorage | null): boolean => !!storage && getTauschbonusFromSails(storage);
